import emailjs from '@emailjs/browser';

// EmailJS Configuration - Replace with your actual values from EmailJS dashboard
const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_20o5uck',  // Replace with your EmailJS Service ID
  TEMPLATE_ID: 'template_5amltx3', // Replace with your EmailJS Template ID
  PUBLIC_KEY: '1Ca_2boiKl3NEijww'    // Replace with your EmailJS Public Key
};

// Email service for sending completed mortgage applications
export const sendApplicationEmail = async (userData, language) => {
  try {
    console.log('Preparing to send mortgage application email via EmailJS...');
    
    // Check if EmailJS is configured
    if (EMAILJS_CONFIG.SERVICE_ID === 'YOUR_SERVICE_ID') {
      console.warn('⚠️ EmailJS not configured yet. Please update EMAILJS_CONFIG in emailService.js');
      console.log('Email Data that would be sent:', {
        to: 's.usmanov@mottomortgage.com',
        subject: 'New Mortgage Application Completed',
        userData: userData,
        language: language,
        timestamp: new Date().toISOString()
      });
      return { success: true, simulated: true };
    }

    // Prepare template parameters for EmailJS
    const templateParams = {
      to_email: 's.usmanov@mottomortgage.com',
      subject: 'New Mortgage Application Completed',
      applicant_name: `${userData.firstName || ''} ${userData.middleName || ''} ${userData.lastName || ''}`.trim() || 'N/A',
      applicant_email: userData.email || 'N/A',
      applicant_phone: userData.phone || 'N/A',
      application_language: getLanguageName(language),
      language_choice: userData.languageChoice || 'N/A',
      submission_date: new Date().toLocaleString('en-US'),
      
      // Personal Information
      date_of_birth: userData.dateOfBirth || 'N/A',
      current_address: userData.currentAddress || 'N/A',
      time_at_address: userData.timeAtAddress || 'N/A',
      housing_status: userData.housingStatus || 'N/A',
      monthly_payment: userData.monthlyPayment || 'N/A',
      
      // Employment Information
      employer: userData.employer || 'N/A',
      job_title: userData.jobTitle || 'N/A',
      employment_type: userData.employmentType || 'N/A',
      employment_length: userData.employmentLength || 'N/A',
      annual_income: userData.annualIncome || 'N/A',
      other_income: userData.otherIncome || 'N/A',
      
      // Loan Information
      purchase_price: userData.purchasePrice || 'N/A',
      loan_purpose: userData.loanPurpose || 'N/A',
      property_type: userData.propertyType || 'N/A',
      occupancy: userData.occupancy || 'N/A',
      credit_score: userData.creditScore || 'N/A',
      citizenship_status: userData.citizenshipStatus || 'N/A',
      
      // Tax Returns
      tax_returns: userData.taxReturns || 'N/A',
      
      // Complete application data as JSON (for backup)
      full_application_data: JSON.stringify(userData, null, 2)
    };

    console.log('Sending email via EmailJS...');
    
    // Send email using EmailJS
    const result = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY
    );

    console.log('✅ Email sent successfully via EmailJS:', result);
    
    // Also send to Google Sheets
    try {
      await sendToGoogleSheets(userData, language);
      console.log('✅ Data sent to Google Sheets successfully');
    } catch (sheetsError) {
      console.warn('⚠️ Failed to send to Google Sheets:', sheetsError);
      // Don't fail the whole process if sheets fails
    }
    
    return { success: true, emailResult: result };
    
  } catch (error) {
    console.error('❌ Error sending email via EmailJS:', error);
    // Don't throw error to avoid disrupting user experience
    return { success: false, error: error.message };
  }
};

// Google Sheets integration
const sendToGoogleSheets = async (userData, language) => {
  // Replace with your actual Google Apps Script web app URL
  const GOOGLE_SHEETS_URL = 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE';
  
  const sheetData = {
    timestamp: new Date().toISOString(),
    language: getLanguageName(language),
    languageChoice: userData.languageChoice || '',
    firstName: userData.firstName || '',
    lastName: userData.lastName || '',
    middleName: userData.middleName || '',
    email: userData.email || '',
    phone: userData.phone || '',
    dateOfBirth: userData.dateOfBirth || '',
    currentAddress: userData.currentAddress || '',
    timeAtAddress: userData.timeAtAddress || '',
    housingStatus: userData.housingStatus || '',
    monthlyPayment: userData.monthlyPayment || '',
    employer: userData.employer || '',
    jobTitle: userData.jobTitle || '',
    employmentType: userData.employmentType || '',
    employmentLength: userData.employmentLength || '',
    annualIncome: userData.annualIncome || '',
    otherIncome: userData.otherIncome || '',
    purchasePrice: userData.purchasePrice || '',
    loanPurpose: userData.loanPurpose || '',
    propertyType: userData.propertyType || '',
    occupancy: userData.occupancy || '',
    creditScore: userData.creditScore || '',
    citizenshipStatus: userData.citizenshipStatus || '',
    taxReturns: userData.taxReturns || ''
  };

  // Only send if URL is configured
  if (GOOGLE_SHEETS_URL === 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE') {
    console.log('📊 Google Sheets not configured yet. Data that would be sent:', sheetData);
    return;
  }

  const response = await fetch(GOOGLE_SHEETS_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(sheetData)
  });

  if (!response.ok) {
    throw new Error(`Google Sheets API error: ${response.status}`);
  }

  return response.json();
};

// formatApplicationData function removed - using EmailJS template instead

const getLanguageName = (language) => {
  const languages = {
    'en': 'English',
    'es': 'Spanish',
    'ru': 'Russian',
    'ky': 'Kyrgyz'
  };
  return languages[language] || 'English';
};